import { render, staticRenderFns } from "./EmailRecover.vue?vue&type=template&id=74d33e41&"
import script from "./EmailRecover.vue?vue&type=script&lang=js&"
export * from "./EmailRecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports